import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout-error',{attrs:{"title":_vm.title,"image":"/img/bug-robot.png"}},[_c('p',[_vm._v(_vm._s(_vm.error.message))]),_c(VBtn,{attrs:{"color":"primary","to":"/"}},[_vm._v("Voltar para o início")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }